import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["needy", "submitButton", "count", "selectAllCheckbox"]

  selectAll(event) {
    this.needyTargets.forEach(cb => cb.checked = event.target.checked)
    this.toggleSubmitButton()
  }

  toggleSubmitButton() {
    const selected = this.needyTargets.filter(cb => cb.checked)
    const hasSelected = selected.length > 0
    this.submitButtonTarget.classList.toggle("hidden", !hasSelected)
    if (hasSelected) this.countTarget.textContent = selected.length
    if (this.hasSelectAllCheckboxTarget) {
      this.selectAllCheckboxTarget.checked = selected.length === this.needyTargets.length
    }
  }

  cancel() {
    this.needyTargets.forEach(cb => cb.checked = false)
    if (this.hasSelectAllCheckboxTarget) this.selectAllCheckboxTarget.checked = false
    this.toggleSubmitButton()
  }

  confirm(event) {
    const checked = this.needyTargets.filter(cb => cb.checked)
    const count = checked.length
    const withDocs = checked.filter(cb => cb.dataset.hasDocuments === "true")

    let msg = ""
    if (withDocs.length > 0) {
      const ids = withDocs.map(cb => cb.dataset.idNumber).join(", ")
      msg += `UWAGA: Wskazani Potrzebujący mają dodane dokumenty:\n${ids}\n\n`
    }
    msg +=
      `Czy na pewno chcesz odrzucić ${count} Potrzebujących?\n` +
      `Wiadomość o odrzuceniu nie zostanie wysłana do Potrzebujących`

    if (!window.confirm(msg)) event.preventDefault()
  }
}
